export const BE_PAY_IN_METHOD__REDIRECT_TYPE = {
  iframe: 'iframe',
}
export const CASHBOX_QUERY = {
  view: {
    key: 'view',
    value: {
      iframe: 'iframe',
    },
  },
}
export const CASHBOX_EVENTS = {
  LEAVE_CASHBOX: 'LEAVE_CASHBOX',
}
